// extracted by mini-css-extract-plugin
export default {"root":"LinksTable_root__1Pmjw","placeHolderShimmer":"LinksTable_placeHolderShimmer__n0K27"};